// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppointmentTop_footer__bswm7"};